import React from 'react';
import QRCode from 'qrcode.react';
import { currencyTypeConstants } from '../../_constants'

export class CompanyInfo extends React.Component{

    render(){
        const {currencyType , isHWGCash , settings , currency } = this.props;

        return (
            (currencyType === currencyTypeConstants.CURRENCYTYPE_DIGITAL_ASSET  ) ? (
                (settings.length > 0) && 
                <React.Fragment>
                    <div className="field is-horizontal">
                        <div className="field-label is-small">
                            <label className="label">Wallet Name</label>
                        </div>
                        <div className="field-body">
                        {
                            settings.find((obj) => { 
                                return obj.lookupName === `${currency}_WALLET_NAME`
                            }).lookupValue
                        } 
                        </div>
                    </div>
                    <div className="field is-horizontal">
                        <div className="field-label is-small">
                            <label className="label">{currency} Address</label>
                        </div>
                        <div className="field-body">
                        {
                            settings.find((obj) => { 
                                return obj.lookupName === `${currency}_ADDRESS`
                            }).lookupValue
                        }
                        </div>
                    </div>
                    <div className="field is-horizontal">
                        <div className="field-label is-small">
                            <label className="label">{currency} QR Code</label>
                        </div>
                        <div className="field-body">
                            <QRCode value={
                                
                                settings.find((obj) => { 
                                    return obj.lookupName === `${currency}_ADDRESS`
                                }).lookupValue
                            } />
                        </div>
                    </div>
                </React.Fragment>
            )
            : (
                (settings.length > 0) && 
                <React.Fragment>
                    <div className="field is-horizontal">
                        <div className="field-label is-small">
                            <label className="label">Bank Name</label>
                        </div>
                        <div className="field-body">{
                            settings.find((obj) => { 
                                return obj.lookupName === 'BANK_NAME'
                            }).lookupValue
                        }</div>
                    </div>
                    <div className="field is-horizontal">
                        <div className="field-label is-small">
                            <label className="label">Account Name</label>
                        </div>
                        <div className="field-body">{
                            settings.find((obj) => { 
                                return obj.lookupName === 'BANK_ACC_NAME'
                            }).lookupValue
                        }</div>
                    </div>
                    <div className="field is-horizontal">
                        <div className="field-label is-small">
                            <label className="label">Account Type</label>
                        </div>
                        <div className="field-body">{
                            settings.find((obj) => { 
                                return obj.lookupName === 'BANK_ACC_TYPE'
                            }).lookupValue
                        }</div>
                    </div>
                    <div className="field is-horizontal">
                        <div className="field-label is-small">
                            <label className="label">Account Number</label>
                        </div>
                        <div className="field-body">{
                            settings.find((obj) => { 
                                return obj.lookupName === 'BANK_ACC_NUM'
                            }).lookupValue
                        }</div>
                    </div>
                </React.Fragment>
            )
    
        )
    }
}


// WEBPACK FOOTER //
// ./src/Views/DepositPage/CompanyInfo.jsx